import {createEndpoint, createPosts, displayCustomTable, displayData, displayTaxonomies} from "../../components/customRoute/Endpoints/Endpoint/EndpointFactory";

function changeEndpointField( state, action ) {
	let existingMethods = state.settings.endpoints.map(endpoint => endpoint.method);
	existingMethods = existingMethods.filter(method => method !== state.settings.endpoints[action.payLoad.endpointId].method);

	return {
		...state,
		existingMethods: [...existingMethods, action.payLoad.value],
		settings: {
			...state.settings,
			endpoints: [
				...state.settings.endpoints.map((el, index) => {
					if (index === action.payLoad.endpointId) {
						el[action.payLoad.field] = action.payLoad.value;

						if (action.payLoad.field === 'enabled') {
							el.opacity = action.payLoad.value ? 1 : 0.5
						}

						if (action.payLoad.field === 'action') {
							el.displayData = displayData;
							el.displayTaxonomies = displayTaxonomies;
							el.displayCustomTable = displayCustomTable;
							el.createPosts = createPosts;
						}
					}

					return el;
				}),
			]
		}
	}
}

function endpointAddNew( state, action ) {
	return {
		...state,
		settings: {
			...state.settings,
			endpoints: [
				...state.settings.endpoints,
				createEndpoint()
			]
		}
	}
}

function endpointRemove( state, action ) {
	let existingMethods = state.existingMethods.filter(method => method !== state.settings.endpoints[action.payLoad.endpointId].method);

	return {
		...state,
		existingMethods: existingMethods,
		settings: {
			...state.settings,
			endpoints: [
				...state.settings.endpoints.filter((el, index) => action.payLoad.endpointId !== index ) ,
			]
		}
	}
}

export { changeEndpointField, endpointAddNew, endpointRemove };